<template>
  <div class="personal">
    <div class="form-box">
      <el-form ref="form" :model="form_pwd" label-width="80px">
        <el-form-item label="旧密码">
          <el-input v-model="form_pwd.oldpassword" type="password" class="form-input" placeholder="请输入旧密码" />
        </el-form-item>
        <el-form-item label="新密码">
          <div style="display: flex; align-items: center; cursor: pointer;">
            <el-input :type="is_view1 ? 'text' : 'password'" v-model="form_pwd.newpassword" class="form-input" placeholder="请输入新密码" />
          </div>
        </el-form-item>
        <el-form-item label="确认密码">
          <div style="display: flex; align-items: center; cursor: pointer;">
            <el-input :type="is_view2 ? 'text' : 'password'" v-model="form_pwd.renewpassword" class="form-input" placeholder="请再次确认密码" />
          </div>
        </el-form-item>

        <el-form-item>
          <div class="submit-btn" @click="confirmPwd">确定修改</div>
        </el-form-item>

      </el-form>
    </div>

  </div>
</template>

<script>
import { apiUserChangePwd } from "@/api/api"
export default {
  name: "personal",
  data() {
    return {
      is_view1: "noview",
      is_view2: "noview",
      form_pwd: {
        oldpassword: '',
        newpassword: '',
        renewpassword: ''
      }
    }
  },
  methods: {
    confirmPwd() {
      if (!this.form_pwd.oldpassword) {
        this.$message.info('请输入旧密码')
        return false
      }
      if (!this.form_pwd.newpassword) {
        this.$message.info('请输入新密码')
        return false
      }
      if (!this.form_pwd.renewpassword) {
        this.$message.info('请再次输入密码')
        return false
      } else {
        if (this.form_pwd.newpassword !== this.form_pwd.renewpassword) {
          this.$message.info('两次密码不一致')
          return false
        }
      }

      if (this.form_pwd.oldpassword === this.form_pwd.newpassword && this.form_pwd.oldpassword === this.form_pwd.renewpassword) {
        this.$message.error('新旧密码一致')
        return false
      }
      apiUserChangePwd(this.form_pwd).then(res => {
        if (res.code === 1) {
          this.$message.success('修改成功！')
          setTimeout(() => {
            this.$store.dispatch('FedLogOut').then(() => {
              location.reload()// In order to re-instantiate the vue-router object to avoid bugs
            })
          }, 2000)
        } else {
          this.$message.info(res.msg)
        }
      }).catch(error => {
        this.$message.info(error.msg)
      })
    },

  }
}
</script>

<style scoped lang="scss">
.personal {

  .form-box {

    .el-form-item {
      margin-bottom: 10px;
    }

    .form-input {
      width: 300px;
    }

    .submit-btn {
      width: 80px;
      height: 30px;
      background-color: #0f375a;
      color: #fff;
      text-align: center;
      line-height: 30px;
      font-size: 12px;
      cursor: pointer;
      user-select: none;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/user/components/personal/index.vue